import * as Sentry from '@sentry/react';

const isProd = import.meta.env.PROD;

isProd &&
  Sentry.init({
    dsn: 'https://9d7d53540468666583aeff16374b1870@o4507639921049600.ingest.de.sentry.io/4507640005984336',
  });
